<!-- 油卡管理 -->
<template>
    <div>
        <template v-if="!isInitialized">
            <div class="block-container">
                <van-empty description="正在读取中..."/>
            </div>
        </template>
        <template v-if="!userList.length && isInitialized">
            <div class="block-container">
                <van-empty description="无用户绑定副卡"/>
            </div>
        </template>
        <template v-if="userList.length && isInitialized">
            <van-cell-group class="user-list-content">
                <van-cell title="item" value="item" v-for="(item, index) in userList" :key="'user'+index">
                    <template #title>
                        <div class="user-info">
                            <van-image
                                width="45"
                                height="45"
                                :src="item.user_info.avatar"/>
                            <span class="user-name">{{item.user_info.nickname}}</span>
                        </div>
                    </template>
                    <template>
                        <div class="user-option">
                            <van-button type="danger" size="normal" :loading="item.loading" @click="unbindCard(item, index)">解绑</van-button>
                        </div>
                    </template>
                </van-cell>
            </van-cell-group>
        </template>
    </div>
</template>

<script>
    import api from '../../assets/js/api'
    import wx from 'weixin-js-sdk'
    export default {
        name: 'SecondaryCardUserList',
        data () {
            return {
                loading: false,
                isInitialized: false,
                userList: [],
                companyId: this.$route.query.user_company_auth_id,
            }
        },
        created() {
            this.refreshUserList()
        },
        methods: {
            unbindCard(item, index) {
                if (this.loading) return false;
                let self = this;
                this.loading = true;
                let toast = this.$toast.loading({
                    message: '解绑中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/user_card/unbind_secondary_card', {
                    user_card_id: item.id,
                }).then(res => {
                    self.userList.splice(index, 1)
                    self.$toast.clear(toast);
                    self.$toast.success(res.msg);
                }).catch(res => {
                    self.$toast.clear(toast);
                    self.$toast.fail(res.msg);
                }).finally(() => {
                    self.refreshUserList()
                })
            },
            refreshUserList() {
                let self = this;
                this.loading = true;
                this.userList = [];
                let toast = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/user_card/secondary_card_list', {
                    user_card_id: this.$route.query.user_card_id
                }).then(res => {
                    self.isInitialized = true;
                    self.$toast.clear(true);
                    self.userList = res.data;
                }).catch(res => {
                    self.$toast.clear(true);
                    self.$toast.fail(res.msg);
                }).finally(() => {
                    self.loading = false;
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .block-container {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background: #fff;

        .van-empty {
            padding-top: 0;
        }
    }

    .user-list-title {
        width: 100%;
        height: 1.5rem;
        border: 1px solid #ddd;
        span {
            line-height: 1.5rem;
            display: block;
            text-align: center;
            color: #999;
            font-size: 16px;
        }
    }
    .user-list-content {
        height: 100%;
        overflow-y: auto;
        .user-info {
            display: flex;
            justify-content: start;
            align-items: center;
            .user-name {
                font-size: 14px;
                color: #666;
                margin-left: 15px;
            }
        }
        .user-option {
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }
    }

</style>


// WEBPACK FOOTER //
// src/pages/card/SecondaryCardUserList.vue